import { render, staticRenderFns } from "./TipoPrecio.vue?vue&type=template&id=58ec888e&"
import script from "./TipoPrecio.vue?vue&type=script&lang=js&"
export * from "./TipoPrecio.vue?vue&type=script&lang=js&"
import style0 from "./TipoPrecio.vue?vue&type=style&index=0&id=58ec888e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports